/* Viva Mejor · Nueva home (componentes vm-*) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function onCartUpdate(callback) {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      return subscribe(PUB_SUB_EVENTS.cartUpdate, callback);
    }
    return function () {};
  }

  function cartJsonUrl() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base.replace(/\/$/, '') + '.js';
  }

  /* ------------------------------------------------------------------
     Cabecera: sticky, ocultar al bajar, contador del carrito
     ------------------------------------------------------------------ */
  if (!customElements.get('vm-header')) {
    customElements.define('vm-header', class VmHeader extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section') || this;
        this.mode = this.dataset.sticky || 'on-scroll-up';
        this.countEls = Array.prototype.slice.call(this.querySelectorAll('[data-vm-cart-count]'));
        this.cartLink = this.querySelector('[data-vm-cart-link]');
        this.sink = this.querySelector('#cart-icon-bubble');
        this.lastY = window.pageYOffset || 0;
        this.isHidden = false;

        this.onScroll = this.onScroll.bind(this);
        if (this.mode === 'on-scroll-up') window.addEventListener('scroll', this.onScroll, { passive: true });

        if (this.sink && 'MutationObserver' in window) {
          this.observer = new MutationObserver(this.readSink.bind(this));
          this.observer.observe(this.sink, { childList: true, subtree: true, characterData: true });
        }

        this.unsubscribe = onCartUpdate(function () {
          this.show(true);
          this.refreshCount();
        }.bind(this));

        this.onPageShow = function (event) {
          if (!event.persisted) return;
          this.closeMenu(true);
          this.refreshCount();
        }.bind(this);
        window.addEventListener('pageshow', this.onPageShow);

        this.onCartClick = this.onCartClick.bind(this);
        if (this.cartLink) this.cartLink.addEventListener('click', this.onCartClick);

        this.menu = this.querySelector('[data-vm-menu]');
        this.menuBtn = this.querySelector('[data-vm-menu-open]');
        if (this.menu && this.menuBtn) this.bindMenu();

        this.bindMobilePlaceholder();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('pageshow', this.onPageShow);
        if (this.cartLink) this.cartLink.removeEventListener('click', this.onCartClick);
        if (this.observer) this.observer.disconnect();
        if (this.unsubscribe) this.unsubscribe();
        clearTimeout(this.countTimer);
        if (this.onMenuKey) document.removeEventListener('keydown', this.onMenuKey);
        if (this.menuOpen) document.documentElement.classList.remove('vm-scroll-lock');
        if (this.mqDesktop && this.onMq) {
          if (this.mqDesktop.removeEventListener) this.mqDesktop.removeEventListener('change', this.onMq);
          else if (this.mqDesktop.removeListener) this.mqDesktop.removeListener(this.onMq);
        }
        if (this.mqMobile && this.onMqMobile) {
          if (this.mqMobile.removeEventListener) this.mqMobile.removeEventListener('change', this.onMqMobile);
          else if (this.mqMobile.removeListener) this.mqMobile.removeListener(this.onMqMobile);
        }
      }

      /* Menú lateral para móvil y tableta */
      bindMenu() {
        this.menuPanel = this.menu.querySelector('.vm-menu__panel');
        this.onMenuKey = this.onMenuKey.bind(this);
        this.menuBtn.addEventListener('click', this.openMenu.bind(this));
        Array.prototype.forEach.call(this.menu.querySelectorAll('[data-vm-menu-close]'), function (el) {
          el.addEventListener('click', this.closeMenu.bind(this));
        }, this);
        if (window.matchMedia) {
          this.mqDesktop = window.matchMedia('(min-width: 990px)');
          this.onMq = function (event) { if (event.matches) this.closeMenu(true); }.bind(this);
          if (this.mqDesktop.addEventListener) this.mqDesktop.addEventListener('change', this.onMq);
          else if (this.mqDesktop.addListener) this.mqDesktop.addListener(this.onMq);
        }
      }

      openMenu() {
        if (!this.menu || this.menuOpen) return;
        this.menuOpen = true;
        this.show(true);
        this.menu.removeAttribute('inert');
        this.menu.setAttribute('aria-hidden', 'false');
        this.menu.classList.add('is-open');
        this.menuBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('vm-scroll-lock');
        document.addEventListener('keydown', this.onMenuKey);
        var close = this.menu.querySelector('.vm-menu__close');
        window.setTimeout(function () { (close || this.menuPanel).focus(); }.bind(this), 60);
      }

      closeMenu(skipFocus) {
        if (!this.menu || !this.menuOpen) return;
        this.menuOpen = false;
        this.menu.classList.remove('is-open');
        this.menu.setAttribute('aria-hidden', 'true');
        this.menu.setAttribute('inert', '');
        this.menuBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('vm-scroll-lock');
        document.removeEventListener('keydown', this.onMenuKey);
        if (skipFocus !== true) this.menuBtn.focus();
      }

      onMenuKey(event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
          event.preventDefault();
          this.closeMenu();
          return;
        }
        if (event.key !== 'Tab' && event.keyCode !== 9) return;
        var items = Array.prototype.filter.call(this.menuPanel.querySelectorAll('a[href], button:not([disabled])'), function (el) {
          return el.offsetWidth > 0 || el.offsetHeight > 0;
        });
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === this.menuPanel)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      /* Texto del buscador más corto en móvil */
      bindMobilePlaceholder() {
        var input = this.querySelector('.vm-search__input[data-placeholder-mobile]');
        if (!input || !window.matchMedia) return;
        var mobileText = input.getAttribute('data-placeholder-mobile');
        if (!mobileText) return;
        var desktopText = input.getAttribute('placeholder') || '';
        this.mqMobile = window.matchMedia('(max-width: 749px)');
        this.onMqMobile = function () {
          input.setAttribute('placeholder', this.mqMobile.matches ? mobileText : desktopText);
        }.bind(this);
        this.onMqMobile();
        if (this.mqMobile.addEventListener) this.mqMobile.addEventListener('change', this.onMqMobile);
        else if (this.mqMobile.addListener) this.mqMobile.addListener(this.onMqMobile);
      }

      onCartClick(event) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          event.preventDefault();
          drawer.open(this.cartLink);
        }
      }

      isBusy() {
        if (this.menuOpen) return true;
        if (this.contains(document.activeElement) && document.activeElement !== document.body) return true;
        return !!this.querySelector('predictive-search[open], predictive-search[loading], .cart-notification.active');
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(function () {
          this.ticking = false;
          var y = Math.max(window.pageYOffset || 0, 0);
          var limit = this.section.offsetHeight + 120;
          if (y > this.lastY + 2 && y > limit) {
            if (!this.isBusy()) this.hide();
          } else if (y < this.lastY - 2 || y <= limit) {
            this.show();
          }
          this.lastY = y;
        }.bind(this));
      }

      hide() {
        if (this.isHidden) return;
        this.isHidden = true;
        this.section.classList.add('vm-header-hidden');
      }

      show(instant) {
        if (!this.isHidden) return;
        this.isHidden = false;
        var section = this.section;
        if (!instant) {
          section.classList.remove('vm-header-hidden');
          return;
        }
        /* Sin animación: la notificación del carrito recibe el foco justo después y
           la cabecera debe estar ya visible para que el navegador no desplace la página. */
        section.classList.add('vm-header-instant');
        section.classList.remove('vm-header-hidden');
        void section.offsetHeight;
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { section.classList.remove('vm-header-instant'); });
        });
      }

      /* API compatible con la cabecera de Dawn */
      reveal() { this.show(true); }

      setCount(count) {
        var n = parseInt(count, 10);
        if (isNaN(n)) return;
        this.countEls.forEach(function (el) {
          if (el.textContent.trim() === String(n)) return;
          el.textContent = n;
          el.classList.remove('is-bump');
          void el.offsetWidth;
          el.classList.add('is-bump');
          setTimeout(function () { el.classList.remove('is-bump'); }, 280);
        });
        if (this.cartLink) {
          var label = this.dataset.cartLabel || 'Carrito';
          this.cartLink.setAttribute('aria-label', label + ': ' + n + (n === 1 ? ' artículo' : ' artículos'));
        }
      }

      readSink() {
        if (!this.sink) return;
        var bubble = this.sink.querySelector('.cart-count-bubble');
        if (!bubble) { this.setCount(0); return; }
        var visible = bubble.querySelector('[aria-hidden="true"]');
        var n = visible ? parseInt(visible.textContent, 10) : NaN;
        if (isNaN(n)) this.refreshCount(); else this.setCount(n);
      }

      refreshCount() {
        clearTimeout(this.countTimer);
        this.countTimer = setTimeout(function () {
          fetch(cartJsonUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (response) { return response.ok ? response.json() : null; })
            .then(function (cart) { if (cart && typeof cart.item_count !== 'undefined') this.setCount(cart.item_count); }.bind(this))
            .catch(function () {});
        }.bind(this), 150);
      }
    });
  }

  /* ------------------------------------------------------------------
     Barra superior: rotación de mensajes en móvil
     ------------------------------------------------------------------ */
  if (!customElements.get('vm-rotator')) {
    customElements.define('vm-rotator', class VmRotator extends HTMLElement {
      connectedCallback() {
        this.items = Array.prototype.slice.call(this.querySelectorAll('.vm-topbar__item'));
        if (this.items.length < 2) return;
        this.index = Math.max(0, this.items.findIndex(function (el) { return el.classList.contains('is-active'); }));
        this.interval = Math.max(2000, parseInt(this.dataset.interval, 10) || 4000);
        this.mq = window.matchMedia('(max-width: 749px)');
        this.tick = this.tick.bind(this);
        this.restart = this.restart.bind(this);
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.restart); else this.mq.addListener(this.restart);
        if (designMode) {
          this.onSelect = function (event) {
            var i = this.items.indexOf(event.target);
            if (i > -1) { this.hold = true; this.show(i); this.restart(); }
          }.bind(this);
          this.onDeselect = function (event) {
            if (this.items.indexOf(event.target) > -1) { this.hold = false; this.restart(); }
          }.bind(this);
          document.addEventListener('shopify:block:select', this.onSelect);
          document.addEventListener('shopify:block:deselect', this.onDeselect);
        }
        this.restart();
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.mq) { if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.restart); else this.mq.removeListener(this.restart); }
        if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
        if (this.onDeselect) document.removeEventListener('shopify:block:deselect', this.onDeselect);
      }

      restart() {
        clearInterval(this.timer);
        if (this.mq.matches && !reduceMotion.matches && !this.hold) this.timer = setInterval(this.tick, this.interval);
      }

      show(i) {
        this.items[this.index].classList.remove('is-active');
        this.index = (i + this.items.length) % this.items.length;
        this.items[this.index].classList.add('is-active');
      }

      tick() {
        if (document.hidden) return;
        this.show(this.index + 1);
      }
    });
  }

  /* ------------------------------------------------------------------
     Hero: carrusel con fundido
     ------------------------------------------------------------------ */
  if (!customElements.get('vm-hero-slider')) {
    customElements.define('vm-hero-slider', class VmHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-vm-slide]'));
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-vm-go]'));
        if (this.slides.length < 2) return;
        this.index = Math.max(0, this.slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
        this.delay = Math.max(3, parseFloat(this.dataset.speed) || 6.5) * 1000;
        this.autoplay = this.dataset.autoplay === 'true';

        var prev = this.querySelector('[data-vm-prev]');
        var next = this.querySelector('[data-vm-next]');
        if (prev) prev.addEventListener('click', function () { this.go(this.index - 1, true); }.bind(this));
        if (next) next.addEventListener('click', function () { this.go(this.index + 1, true); }.bind(this));
        this.tabs.forEach(function (tab) {
          tab.addEventListener('click', function () { this.go(parseInt(tab.dataset.vmGo, 10) || 0, true); }.bind(this));
        }, this);

        this.addEventListener('mouseenter', function () { this.hovering = true; this.stop(); }.bind(this));
        this.addEventListener('mouseleave', function () { this.hovering = false; this.start(); }.bind(this));
        this.addEventListener('focusin', function () { this.focused = true; this.stop(); }.bind(this));
        this.addEventListener('focusout', function (event) {
          if (!this.contains(event.relatedTarget)) { this.focused = false; this.start(); }
        }.bind(this));
        this.onVisibility = function () { if (document.hidden) this.stop(); else this.start(); }.bind(this);
        document.addEventListener('visibilitychange', this.onVisibility);

        this.bindSwipe();
        if (designMode) this.bindEditor();
        this.update();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
        if (this.onDeselect) document.removeEventListener('shopify:block:deselect', this.onDeselect);
      }

      go(i, byUser) {
        var n = this.slides.length;
        this.index = ((i % n) + n) % n;
        this.update();
        if (byUser) this.start();
      }

      update() {
        this.slides.forEach(function (slide, i) {
          var active = i === this.index;
          slide.classList.toggle('is-active', active);
          if (active) { slide.removeAttribute('aria-hidden'); slide.removeAttribute('tabindex'); }
          else { slide.setAttribute('aria-hidden', 'true'); slide.setAttribute('tabindex', '-1'); }
        }, this);
        this.tabs.forEach(function (tab, i) {
          if (i === this.index) tab.setAttribute('aria-current', 'true'); else tab.removeAttribute('aria-current');
        }, this);
        var bg = this.slides[this.index].getAttribute('data-bg');
        if (bg) this.style.setProperty('--vm-cur-bg', bg);
      }

      start() {
        this.stop();
        if (!this.autoplay || reduceMotion.matches || this.hovering || this.focused || this.editorHold || document.hidden) return;
        this.timer = setInterval(function () { this.go(this.index + 1); }.bind(this), this.delay);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      bindSwipe() {
        var startX = null, startY = null, moved = false;
        this.addEventListener('touchstart', function (event) {
          var t = event.touches[0];
          startX = t.clientX; startY = t.clientY; moved = false;
          this.stop();
        }.bind(this), { passive: true });
        this.addEventListener('touchmove', function (event) {
          if (startX === null) return;
          var t = event.touches[0];
          var dx = t.clientX - startX, dy = t.clientY - startY;
          if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) moved = true;
        }, { passive: true });
        this.addEventListener('touchend', function (event) {
          if (startX === null) return;
          var dx = event.changedTouches[0].clientX - startX;
          if (moved && Math.abs(dx) > 40) {
            this.swipedAt = Date.now();
            this.go(this.index + (dx < 0 ? 1 : -1), true);
          } else {
            this.start();
          }
          startX = null;
        }.bind(this), { passive: true });
        this.addEventListener('click', function (event) {
          if (this.swipedAt && Date.now() - this.swipedAt < 450) { event.preventDefault(); event.stopPropagation(); }
        }.bind(this), true);
      }

      bindEditor() {
        this.onSelect = function (event) {
          var i = this.slides.indexOf(event.target);
          if (i > -1) { this.editorHold = true; this.stop(); this.go(i); }
        }.bind(this);
        this.onDeselect = function (event) {
          if (this.slides.indexOf(event.target) > -1) { this.editorHold = false; this.start(); }
        }.bind(this);
        document.addEventListener('shopify:block:select', this.onSelect);
        document.addEventListener('shopify:block:deselect', this.onDeselect);
      }
    });
  }

  /* ------------------------------------------------------------------
     Cuenta atrás (semanal hasta el domingo 23:59 o fecha fija)
     ------------------------------------------------------------------ */
  if (!customElements.get('vm-countdown')) {
    customElements.define('vm-countdown', class VmCountdown extends HTMLElement {
      connectedCallback() {
        this.d = this.querySelector('[data-d]');
        this.h = this.querySelector('[data-h]');
        this.m = this.querySelector('[data-m]');
        this.render();
        this.timer = setInterval(this.render.bind(this), 30000);
      }

      disconnectedCallback() { clearInterval(this.timer); }

      target() {
        var raw = (this.dataset.end || '').trim();
        if (raw) {
          var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/);
          if (m) {
            var hasTime = typeof m[4] !== 'undefined';
            return new Date(+m[1], +m[2] - 1, +m[3], hasTime ? +m[4] : 23, hasTime ? +m[5] : 59, hasTime ? 0 : 59);
          }
        }
        var now = new Date();
        var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + ((7 - now.getDay()) % 7), 23, 59, 59);
        return end;
      }

      render() {
        var ms = Math.max(0, this.target() - new Date());
        var pad = function (v) { return (v < 10 ? '0' : '') + v; };
        if (this.d) this.d.textContent = Math.floor(ms / 864e5);
        if (this.h) this.h.textContent = pad(Math.floor(ms / 36e5) % 24);
        if (this.m) this.m.textContent = pad(Math.floor(ms / 6e4) % 60);
      }
    });
  }

  /* ------------------------------------------------------------------
     Carrusel horizontal (síntomas)
     ------------------------------------------------------------------ */
  if (!customElements.get('vm-carousel')) {
    customElements.define('vm-carousel', class VmCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-vm-track]');
        if (!this.track) return;
        this.prevBtn = this.querySelector('[data-vm-car-prev]');
        this.nextBtn = this.querySelector('[data-vm-car-next]');
        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = Math.max(2000, parseInt(this.dataset.interval, 10) || 3200);
        this.holdUntil = 0;
        this.inView = !('IntersectionObserver' in window);

        if (this.prevBtn) this.prevBtn.addEventListener('click', function () { this.step(-1, false); this.hold(6000); }.bind(this));
        if (this.nextBtn) this.nextBtn.addEventListener('click', function () { this.step(1, true); this.hold(6000); }.bind(this));

        var holdShort = function () { this.hold(6000); }.bind(this);
        ['touchstart', 'pointerdown', 'wheel', 'focusin', 'keydown'].forEach(function (type) {
          this.track.addEventListener(type, holdShort, { passive: true });
        }, this);
        this.track.addEventListener('mouseenter', function () { this.holdUntil = Infinity; }.bind(this));
        this.track.addEventListener('mouseleave', function () { this.holdUntil = Date.now() + 1500; }.bind(this));

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (entries) {
            this.inView = entries.some(function (e) { return e.isIntersecting; });
          }.bind(this), { threshold: 0.35 });
          this.io.observe(this);
        }

        if (this.autoplay && !reduceMotion.matches) this.timer = setInterval(this.auto.bind(this), this.interval);

        if (designMode) {
          this.onSelect = function (event) {
            if (!this.track.contains(event.target)) return;
            this.hold(Infinity);
            this.track.scrollTo({ left: Math.max(0, event.target.offsetLeft - this.track.offsetLeft - 2), behavior: 'smooth' });
          }.bind(this);
          this.onDeselect = function (event) { if (this.track.contains(event.target)) this.hold(1500); }.bind(this);
          document.addEventListener('shopify:block:select', this.onSelect);
          document.addEventListener('shopify:block:deselect', this.onDeselect);
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.io) this.io.disconnect();
        if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
        if (this.onDeselect) document.removeEventListener('shopify:block:deselect', this.onDeselect);
      }

      hold(ms) { this.holdUntil = ms === Infinity ? Infinity : Date.now() + ms; }

      stepSize() {
        var card = this.track.querySelector('[data-vm-card]');
        if (!card) return this.track.clientWidth * 0.8;
        var style = window.getComputedStyle(this.track);
        var gap = parseFloat(style.columnGap || style.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      atEnd() { return this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4; }

      step(direction, loop) {
        if (loop && direction > 0 && this.atEnd()) { this.track.scrollTo({ left: 0, behavior: 'smooth' }); return; }
        if (loop && direction < 0 && this.track.scrollLeft <= 2) { this.track.scrollTo({ left: this.track.scrollWidth, behavior: 'smooth' }); return; }
        this.track.scrollBy({ left: direction * this.stepSize(), behavior: 'smooth' });
      }

      auto() {
        if (!this.inView || document.hidden) return;
        if (this.holdUntil === Infinity || Date.now() < this.holdUntil) return;
        this.step(1, true);
      }
    });
  }

  /* ------------------------------------------------------------------
     Pestañas de filtrado (más vendidos)
     ------------------------------------------------------------------ */
  if (!customElements.get('vm-tabs')) {
    customElements.define('vm-tabs', class VmTabs extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-vm-tab]'));
        this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-vm-group]'));
        this.buttons.forEach(function (button) {
          button.addEventListener('click', function () { this.select(button.dataset.vmTab); }.bind(this));
        }, this);
        if (designMode) {
          this.onSelect = function (event) {
            if (this.cards.indexOf(event.target) > -1 && event.target.hidden) this.select('todos');
          }.bind(this);
          document.addEventListener('shopify:block:select', this.onSelect);
        }
      }

      disconnectedCallback() {
        if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
      }

      select(key) {
        this.buttons.forEach(function (button) {
          button.setAttribute('aria-pressed', button.dataset.vmTab === key ? 'true' : 'false');
        });
        this.cards.forEach(function (card) {
          card.hidden = !(key === 'todos' || card.dataset.vmGroup === key);
        });
      }
    });
  }

  /* ------------------------------------------------------------------
     Confirmación visual "Añadido" en los botones vm-atc
     ------------------------------------------------------------------ */
  if (!window.__vmAtcFeedback) {
    window.__vmAtcFeedback = true;
    onCartUpdate(function (event) {
      if (!event || event.source !== 'product-form') return;
      var id = String(event.productVariantId || '');
      Array.prototype.forEach.call(document.querySelectorAll('.vm-atc'), function (form) {
        var input = form.querySelector('input[name="id"]');
        var button = form.querySelector('button[type="submit"]');
        if (!input || !button || String(input.value) !== id) return;
        var label = button.querySelector('span');
        if (!label) return;
        if (!button.dataset.vmLabel) button.dataset.vmLabel = label.textContent;
        label.textContent = button.dataset.vmAddedLabel || '✓ Añadido';
        button.classList.add('is-added');
        clearTimeout(button.vmTimer);
        button.vmTimer = setTimeout(function () {
          label.textContent = button.dataset.vmLabel;
          button.classList.remove('is-added');
        }, 2400);
      });
    });
  }
})();
